// 
import { getDataSet } from '../lib/dataset';
import { decorateAdd, decorateRemove, decorateSetValue } from './actions';
import WebComponent from './WebComponent';

let store = null;

export const connectInlineComponents = (reduxStore) => {
  store = reduxStore;
};

let getWebComponent = null;
const decoratedWebComponents = {};

/**
 * Připojí do dekorovacího mechanismu funkci, která rozhodne
 * na jaký element bude použita jaká komponenta
 */
export const connectWebComponents = (configureWebComponents, skipDecorateInnerElements) => {
  getWebComponent = configureWebComponents;
  if (!skipDecorateInnerElements) {
    decorateInnerElements(document.body);
  }
};

const webComponentFactory = (WebComponentClass, element, props) => {
  const webComponent = new WebComponentClass(props);
  element.setAttribute('data-web-component', '');
  const id = element.getAttribute('id');
  if (!id) {
    setTimeout(() => {
      throw new Error(
        `Element na kterém inicializujete web componentu ${webComponent.constructor.name} nemá ID attribute. Doplňte jej.`);
    }, 0);
  }
  if (id) {
    decoratedWebComponents[id] = webComponent;
  }
  webComponent.decorate(element);
  return webComponent;
};

export const decorateElement = (element, skip) => {
  const dataset = { ...getDataSet(element), decorateSkip_: skip};
  let webComponent;
  if (getWebComponent) {
    const WebComponentClass = getWebComponent(dataset);
    if (WebComponentClass) {
      webComponent = true;
      const isPromise = typeof WebComponentClass.then === 'function';
      if (isPromise) {
        WebComponentClass
          .then((WebComponentClassAfterPromise) => {
            webComponentFactory(WebComponentClassAfterPromise.default, element, dataset);
            return true;
          });
      } else {
        webComponent = webComponentFactory(WebComponentClass, element, dataset);
      }
    }
  }
  if (!webComponent && store) {
    const id = element.getAttribute('id');
    store.dispatch(decorateAdd(id, dataset, element));
    element.setAttribute('data-react-component', '');
  }
};

export const removeDecoratedReactComponent = (element) => {
  const id = element.getAttribute('id');
  if (store) {
    store.dispatch(decorateRemove(id));
  }
};

export const disposeDecoratedComponent = (element) => {
  const id = element.getAttribute('id');
  const hasReactWebComponent = element.getAttribute('data-react-component') != null;
  if (hasReactWebComponent) {
    removeDecoratedReactComponent(element);
  } else {
    const webComponent = decoratedWebComponents[id];
    if (webComponent) {
      webComponent.dispose();
      delete decoratedWebComponents[id];
    }
  }
};

/**
 * Zavolá destruktor na všech komponentách, které jsou nadekorovány uvnitř definovaného elementu
 * Využívá se pokud se z domu maže nějaký element tak, aby bylo zajištěno vyčištění garbage
 * collectoru a odstranění event listenerů spojených s komponentou
 */
export const disposeInnerComponents = (element, skip) => {
  const elements = [...element.querySelectorAll('[data-web-component], [data-react-component]')];
  if (element.getAttribute('data-web-component') != null || element.getAttribute('data-react-component') != null) {
    elements.unshift(element);
  }

  elements.forEach((element) => {
    if (!(skip && skip.includes(element.id))) {
      disposeDecoratedComponent(element);
    }
  });
};

/**
 * Nadekoruje všechny elementy s data attribteb data-is nebo data-decorator
 * uvnitř contextElementu včetně
 */
export const decorateInnerElements = (contextElement, skip) => {
  const elements = [...contextElement.querySelectorAll('[data-is], [data-decorator]')];
  if (contextElement.getAttribute('data-is') != null || contextElement.getAttribute('data-decorator') != null) {
    elements.unshift(contextElement);
  }
  elements.forEach((element) => {
    if (!(skip && skip.includes(element.id))) {
      decorateElement(element, skip);
    }
  });
};

/**
 * Získá instanci komponenty na specifikovaném elementu
 */
export const getWebComponentInstance = (element) => {
  if (element) {
    const id = element.getAttribute('id');
    const hasValidDataAttribute = element.getAttribute('data-web-component') != null;
    const hasValidDataAttributeForReact = element.getAttribute('data-react-component') != null;
    if (hasValidDataAttribute && id) {
      return decoratedWebComponents[id] || null;
    }
    if (hasValidDataAttributeForReact) {
      const componentsState = store.getState()['inlineComponents'];
      return componentsState[id] && componentsState[id].instance && componentsState[id].instance.wrappedComponent ? componentsState[id].instance.wrappedComponent : null;
    }
  }
  return null;
};

export const setValue = (elementId, value, arrayLike) => {
  if (arrayLike) {
    value = value == null
      ? []
      : Array.isArray(value)
        ? value.map((value) => value.toString())
        : [value.toString()];
  }
  store.dispatch(decorateSetValue(elementId, value));
};



// WEBPACK FOOTER //
// ./node_modules/@fg/fg-frontend/src/webComponents/decorate.js